import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";

const TimelineData = [
    {
        id: "1",
        title: "Project Analysis Selection",
        description: "Using Big Data to identify potential development projects.",
    },
    {
        id: "2",
        title: "Land Acquisition Negotiation",
        description: "Data-guided negotiations for purchasing land.",
    },
    {
        id: "3",
        title: "Market Analysis for Planning",
        description: "Employing algorithms to analyse market trends and guide project planning.",
    },
    {
        id: "4",
        title: "Building Development Approval",
        description: "Navigating the plan and approval process for development.",
    },
    // {
    //     id: "5",
    //     title: "Sales Management",
    //     description: "Overseeing the sales process of the developed property.",
    // },
]

const TimelineTwo = ({classVar}) => {
    return (
        <div className="timeline-style-two bg-color-blackest">
            <div className="row row--0">
                {/* Start Single Progress */}
                {TimelineData.map((data , index) =>(
                    <div className={`col-lg-3 col-md-3 rn-timeline-single ${classVar}`} key={index}>
                        <div className="rn-timeline">
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <h6 className="title">{data.title}</h6>
                            </ScrollAnimation>
                            <div className="progress-line">
                                <div className="line-inner"></div>
                            </div>
                            <div className="progress-dot">
                                <div className="dot-level">
                                    <div className="dot-inner"></div>
                                </div>
                            </div>
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <p className="description">{data.description}</p>
                            </ScrollAnimation>
                        </div>
                    </div>
                ))}
                {/* End Single Progress */}
            </div>
        </div>
    )
}
export default TimelineTwo;